
type IFormatFloorArg = {
    floor?: number;
    floorsTotal?: number;
}

/**
 * Возвращает русскоязычную запись номера этажа
 * @param {IFormatFloorArg} args
 * @param {number} args.floor
 * @param {number} args.floorsTotal
 * @returns {string}
 * @example
 * formatFloor({ floor: 1, floorsTotal: 3 }) -> '1/3 этаж'
 * formatFloor({ floor: 1 }) -> '1 этаж'
 */
export const formatFloor = ({ floor, floorsTotal }: IFormatFloorArg): string => {
    if (floor && floorsTotal) {
        return `${floor}/${floorsTotal}\u00A0этаж`;
    }

    if (floor) {
        return `${floor} этаж`;
    }

    return '';
};
